/**
 * 从完整 URL 中提取基础路径（# 之前的部分 + '#/'）
 * 例：http://host/#/news/overview?theme=dark  →  http://host/#/
 */
export function getBaseUrl(url: string): string {
  const hashIndex = url.indexOf('#')
  if (hashIndex === -1) return url
  return url.substring(0, hashIndex) + '#/'
}

// C++ 调用：交易日切换时刷新页面
export function on_tradingday_changed() {
  console.log('C++ 调用：交易日切换时刷新页面')
  window.location.reload()
}

/**
 * 在新窗口中打开新闻详情页
 * @param id 新闻 ID
 * @param title 窗口标题（可选） 
 * @param decryptId 新闻 decryptId（可选）
 */
export function openNewsWindow(id: number | string | null, title?: string, decryptId?: string): void {
  const baseUrl = getBaseUrl(window.location.href)
  const titlePart = title ? `;title=${encodeURIComponent(title)}` : ''

  // 合并 search 和 hash query 参数，hash 优先，排除 theme
  const params     = new URLSearchParams(window.location.search)
  const hashParams = new URLSearchParams(window.location.hash.split('?')[1] || '')
  const isGuangTheme = hashParams.get('isGuangTheme') || params.get('isGuangTheme')
  const theme      = hashParams.get('theme') || params.get('theme')
  const merged = new URLSearchParams()
  for (const [key, value] of params.entries()) {
    if (key === 'theme' || key === 'isGuangTheme') continue
    merged.set(key, value)
  }
  for (const [key, value] of hashParams.entries()) {
    if (key === 'theme' || key === 'isGuangTheme') continue
    merged.set(key, value)
  }
  // 仅广发主题：透传 isGuangTheme + theme，供详情页广告位切换素材
  // if (isGuangTheme === '1') {
    merged.set('isGuangTheme', '1')
    if (theme) merged.set('theme', theme)
  // }
  const queryPart = merged.toString()

  const query = [`selectedId=${decryptId}`, queryPart].filter(Boolean).join('&')
  const url = `gw://webkitdlg?width=948;height=575;mode=0${titlePart};allowdestroy=1;url=${baseUrl}newsDetail?${query}`
  window.open(url)
}

/** 广告点击交互类型：1-客户端内功能 2-跳转合约 3-弹框网页 4-默认浏览器 5-其他(含内嵌页) */
export type AdvertClickType = 1 | 2 | 3 | 4 | 5

export interface AdvertTrackInfo {
  adCode?: string
  sourceId?: string
  popupFrequency?: string | number
  /** guideContent 或 pcJumpLink 解析后的跳转链接 */
  link?: string
}

/**
 * 从素材信息中取跳转链接，优先 guideContent
 */
export function resolveAdvertJumpLink(material: {
  guideContent?: string
  pcJumpLink?: string
}): string {
  return (material.guideContent || material.pcJumpLink || '').trim()
}

/**
 * 根据 guideContent / 跳转链接解析广告点击交互类型
 */
export function parseAdvertClickType(link: string): AdvertClickType {
  if (!link) return 5
  const lower = link.toLowerCase()

  if (lower.includes('funcname=ongofenshi')) return 2
  if (lower.startsWith('gw://webkitdlg')) return 3
  if (lower.startsWith('gw://openurl')) return 4
  if (lower.includes('openinnerweb') || lower.includes('command=openinnerweb')) return 5
  if (lower.includes('funcname=ondocommand')) return 1

  return 5
}

/**
 * 弹出频次：dailyFreguency 与 frequencyType 后台单选，有值取有值的
 */
export function getAdvertPopupFrequency(ad: Record<string, unknown>): string | number {
  const val = ad.dailyFreguency ?? ad.dailyFrequency ?? ad.frequencyType
  if (val === undefined || val === null || val === '') return ''
  return val as string | number
}

/**
 * 方德埋点上报
 * 格式：gw://funccall?funcname=ReportBuriedPointInfo;eventtype={eventType};attr={key=value,...}
 * @param eventType 事件名称
 * @param attrs     事件属性键值对
 */
export function reportBuriedPoint(eventType: string, attrs: Record<string, string | number>): void {
  const attrStr = Object.entries(attrs)
    .map(([k, v]) => `${k}=${v}`)
    .join(',')
  const url = `gw://funccall?funcname=ReportBuriedPointInfo;eventtype=${eventType};attr={${attrStr}}`
  window.open(url)
}

/** 广告点击埋点：eventtype=click_event，activityid=adCode，materialid=sourceId，type 由链接解析 */
export function reportAdvertClick(pageTitle: string, info: AdvertTrackInfo): void {
  reportBuriedPoint('click_event', {
    page_title: pageTitle,
    activityid: info.adCode ?? '',
    materialid: info.sourceId ?? '',
    type: parseAdvertClickType(info.link ?? ''),
  })
}

/** 广告曝光埋点：eventtype=show_login_ad */
export function reportAdvertExposure(pageTitle: string, info: AdvertTrackInfo): void {
  console.log('reportAdvertExposure',pageTitle,info)
  reportBuriedPoint('show_login_ad', {
    page_title: pageTitle,
    activityid: info.adCode ?? '',
    materialid: info.sourceId ?? '',
    popupFrequency: info.popupFrequency ?? '',
  })
}

/** 批量上报广告曝光（广告加载完成时调用） */
export function reportAdvertSlidesExposure(pageTitle: string, slides: AdvertTrackInfo[]): void {
  for (const slide of slides) {
    reportAdvertExposure(pageTitle, slide)
  }
}
